import {useMemo} from "react";
import {useRoomConfig} from "../RoomConfigContext";
import {getAngleScore, getMaximumOffset} from "../utils/speakerUtils";
import {useScreenConfig} from "../ScreenConfigContext";
import {createScore, updateScore} from "../utils/score";
import {ErrorCodes} from "../ErrorCodes";
import {getAngle} from "../utils/trig";
import {useSeatConfig} from "../SeatConfigContext";

// ceiling speakers don't use the regular constraint / validation ruleset. Instead, their positions are entirely
// calculated before validation
export const useFrontSpeakerValidator = (config, positions, builtInWall) => {
    const {width} = useRoomConfig();
    const {screenSize, acousticTransparent} = useScreenConfig();
    const {primaryEarPosition} = useSeatConfig();

    return useMemo(() => {
        const score = createScore();

        // use the diagonal as the minimum offset to walls
        const maxW = builtInWall? config.size[0] * .5 : getMaximumOffset(config.size) * .5;

        // they're always symmetric, so just use the first speaker's x position
        const x = positions[0].position[0];

        if (builtInWall && acousticTransparent) {
            const maxX = screenSize * .5 - maxW;
            if (screenSize < 270 && x > maxX)
                updateScore(score, 3, ErrorCodes.FrontSpeakersNotBehindAcousticScreen);
        }
        else {
            const minX = screenSize * .5 + maxW;
            if (x < minX) {
                updateScore(score, 3, ErrorCodes.FrontSpeakersBlockScreen);
            }
            else {
                const maxX = width * .5 - maxW;
                if (x > maxX)
                    updateScore(score, 3, ErrorCodes.FrontSpeakersTooCloseToWalls);
            }
        }


        // ignore angle for built-in speakers
        if (!builtInWall) {
            const angle = getAngle(x, -primaryEarPosition[2]);
            updateScore(
                score,
                getAngleScore(angle, 26, 22, 30, 4),
                ErrorCodes.FrontSpeakersWrongAngle
            );
        }

        return score;
    }, [config.size, width, screenSize, positions, primaryEarPosition, builtInWall, acousticTransparent]);}
